import { Invoice } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import {
  PAYMENT_SEARCH_DEFAULTS,
  paymentSearchConfig,
  type PaymentSearchParams,
} from './paymentSearchConfig';

export type { PaymentSearchParams };
export { PAYMENT_SEARCH_DEFAULTS };

export function usePaymentSearch(
  medplum: MedplumClient,
  patientId?: string
) {
  return useGenericResourceSearch<PaymentSearchParams, Invoice>(
    medplum,
    paymentSearchConfig,
    patientId
  );
}
